<div class="container mt-4">
  <mat-tab-group>
    <mat-tab [label]="'sigt.global.menu.rechercheUtilisateur' | translate">
      <pilotage-users></pilotage-users>
    </mat-tab>

    <mat-tab [label]="'sigt.global.menu.statistiquesConnexion' | translate">
      <pilotage-statistiques></pilotage-statistiques>
    </mat-tab>

     <mat-tab [label]="'sigt.global.menu.consultationsPubliques' | translate">
      <pilotage-consultation-publique></pilotage-consultation-publique>
    </mat-tab>

    <mat-tab [label]="'sigt.global.menu.parametres' | translate">
      <pilotage-parametres></pilotage-parametres>
    </mat-tab>
  </mat-tab-group>
</div>
